import moment from 'moment';

export const groupsTranslationMap = {
  // Current categories
  'Chicas_Cyphers_(14_a_17_años)': 'Adolescentes(14 a 17)',
  'Chicos_Cyphers_(14_a_17_años)': 'Adolescentes(14 a 17)',
  'Hombres_Adultos_(36_-_45_años)': 'Adultos (36 a 45)',
  'Hombres_Adultos_Jóvenes_(26_-_35_años)': 'Adultos Jóvenes (26 a 35)',
  'Hombres_Adultos_Maduros_(45_-_59_años)': 'Adultos Maduros (45 a 59)',
  'Hombres_Adultos_Mayores_(60_años_o_más)': 'Adulto Mayor (60+)',
  'Hombres_Cypher_+_(18_-21_años)': 'Cypher + (18 a 21)',
  'Hombres_Jóvenes_(18-25_años)': 'Jóvenes (18 a 25)',
  'Mixto_79_(7_a_9_años)': 'Niños(7 a 13)',
  'Mixto_Adultos_(36_-_45_años)': 'Adultos (36 a 45)',
  'Mixto_Adultos_Jóvenes_(26_-_35_años)': 'Adultos Jóvenes (26 a 35)',
  'Mixto_Adultos_Maduros_(45_-_59_años)': 'Adultos Maduros (45 a 59)',
  'Mixto_Adultos_Mayores_(60_años_o_más)': 'Adulto Mayor (60+)',
  'Mixto_Cyphers_(14_a_17_años)': 'Adolescentes(14 a 17)',
  'Mixtos_Cypher_+_(18_-21_años)': 'Cypher + (18 a 21)',
  'Mixto_Jóvenes_(18-25_años)': 'Jóvenes (18 a 25)',
  'Mixto_Nxt_(10_a_13_años)': 'Niños(7 a 13)',
  'Mujeres_Adultas_(36_-_45_años)': 'Adultos (36 a 45)',
  'Mujeres_Adultas_Jóvenes_(26_-_35_años)': 'Adultos Jóvenes (26 a 35)',
  'Mujeres_Adultas_Maduras_(45_-_59_años)': 'Adultos Maduros (45 a 59)',
  'Mujeres_Adultas_Mayores_(60_años_o_más)': 'Adulto Mayor (60+)',
  'Mujeres_Cypher_+_(18_-21_años)': 'Cypher + (18 a 21)',
  'Mujeres_Jóvenes_(18-25_años)': 'Jóvenes (18 a 25)',
  'Niñas_79_(7_a_9_años)': 'Niños(7 a 13)',
  'Niñas_Nxt_(10_a_13_años)': 'Niños(7 a 13)',
  'Niños_79_(7_a_9_años)': 'Niños(7 a 13)',
  'Niños_Nxt_(10_a_13_años)': 'Niños(7 a 13)',
  'Parejas_Adultas_Jóvenes_(26_-_44)': 'Parejas (26 a 44)',
  'Parejas_Adultas_Mayores_(45_años_o_más)': 'Parejas (45+)',
};

export const CURRENT_GENERATION_LABELS = [...new Set(Object.values(groupsTranslationMap))];

export const GENERATION_DISPLAY_ORDER = [
  'Niños(7 a 13)',
  'Adolescentes(14 a 17)',
  'Cypher + (18 a 21)',
  'Jóvenes (18 a 25)',
  'Adultos Jóvenes (26 a 35)',
  'Adultos (36 a 45)',
  'Adultos Maduros (45 a 59)',
  'Adulto Mayor (60+)',
  'Parejas (26 a 44)',
  'Parejas (45+)',
];

export const sortGenerationLabels = (labels = []) => {
  const order = ['Todos', ...GENERATION_DISPLAY_ORDER];
  return [...labels].sort((a, b) => {
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);
    if (ia === -1 && ib === -1) return String(a).localeCompare(String(b), 'es');
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });
};

/** Maps an activityName (current or historical) onto the current generation labels. */
export const getGroupGeneration = (activityName) => {
  if (!activityName) return activityName;
  if (groupsTranslationMap[activityName]) return groupsTranslationMap[activityName];
  if (CURRENT_GENERATION_LABELS.includes(activityName)) return activityName;

  const name = String(activityName);

  if (/parejas/i.test(name)) {
    if (/(?:45|más|mas|mayor)/i.test(name) && !/26/.test(name)) return 'Parejas (45+)';
    return 'Parejas (26 a 44)';
  }

  if (/(?:7_a_9|10_a_13|_nxt_|_79_|niñ[oa])/i.test(name)) return 'Niños(7 a 13)';
  if (/(?:cypher_\+|18_-21|18_-_21)/i.test(name)) return 'Cypher + (18 a 21)';
  if (/(?:cyphers|14_a_17)/i.test(name)) return 'Adolescentes(14 a 17)';
  if (/(?:18-25|18_a_25|18_-_25|youth)/i.test(name)) return 'Jóvenes (18 a 25)';

  if (/(?:más_de_56|mas_de_56|60_años|60\+|mayor_55)/i.test(name)) return 'Adulto Mayor (60+)';
  if (/(?:46_a_55|45_-_59|45_a_59|madur)/i.test(name)) return 'Adultos Maduros (45 a 59)';
  if (/(?:36_-_45|36_a_45)/i.test(name)) return 'Adultos (36 a 45)';
  if (/(?:26_-_35|26_a_35|26_-_44|26_a_40|26_a_44)/i.test(name)) {
    return 'Adultos Jóvenes (26 a 35)';
  }

  if (/(?:jóven|joven)/i.test(name) && /adulto/i.test(name)) return 'Adultos Jóvenes (26 a 35)';
  if (/(?:jóven|joven)/i.test(name)) return 'Jóvenes (18 a 25)';
  if (/adulto/i.test(name)) return 'Adultos (36 a 45)';

  return activityName;
};

const getAge = (birthdate) => moment().diff(birthdate, 'years');

const getGenderSpecificActivityName = ({ gender, birthdate }) => {
  const age = getAge(birthdate);
  const isFemale = gender === 'Femenino';

  if (age >= 7 && age <= 9) {
    return isFemale ? 'Niñas_79_(7_a_9_años)' : 'Niños_79_(7_a_9_años)';
  }
  if (age >= 10 && age <= 13) {
    return isFemale ? 'Niñas_Nxt_(10_a_13_años)' : 'Niños_Nxt_(10_a_13_años)';
  }
  if (age >= 14 && age <= 17) {
    return isFemale ? 'Chicas_Cyphers_(14_a_17_años)' : 'Chicos_Cyphers_(14_a_17_años)';
  }
  if (age >= 18 && age <= 21) {
    return isFemale ? 'Mujeres_Cypher_+_(18_-21_años)' : 'Hombres_Cypher_+_(18_-21_años)';
  }
  if (age >= 22 && age <= 25) {
    return isFemale ? 'Mujeres_Jóvenes_(18-25_años)' : 'Hombres_Jóvenes_(18-25_años)';
  }
  if (age >= 26 && age <= 35) {
    return isFemale
      ? 'Mujeres_Adultas_Jóvenes_(26_-_35_años)'
      : 'Hombres_Adultos_Jóvenes_(26_-_35_años)';
  }
  if (age >= 36 && age <= 45) {
    return isFemale ? 'Mujeres_Adultas_(36_-_45_años)' : 'Hombres_Adultos_(36_-_45_años)';
  }
  if (age >= 46 && age <= 59) {
    return isFemale
      ? 'Mujeres_Adultas_Maduras_(45_-_59_años)'
      : 'Hombres_Adultos_Maduros_(45_-_59_años)';
  }
  if (age >= 60) {
    return isFemale
      ? 'Mujeres_Adultas_Mayores_(60_años_o_más)'
      : 'Hombres_Adultos_Mayores_(60_años_o_más)';
  }

  return null;
};

const getMixedActivityName = ({ birthdate }) => {
  const age = getAge(birthdate);

  if (age >= 7 && age <= 9) return 'Mixto_79_(7_a_9_años)';
  if (age >= 10 && age <= 13) return 'Mixto_Nxt_(10_a_13_años)';
  if (age >= 14 && age <= 17) return 'Mixto_Cyphers_(14_a_17_años)';
  if (age >= 18 && age <= 21) return 'Mixtos_Cypher_+_(18_-21_años)';
  if (age >= 22 && age <= 25) return 'Mixto_Jóvenes_(18-25_años)';
  if (age >= 26 && age <= 35) return 'Mixto_Adultos_Jóvenes_(26_-_35_años)';
  if (age >= 36 && age <= 45) return 'Mixto_Adultos_(36_-_45_años)';
  if (age >= 46 && age <= 59) return 'Mixto_Adultos_Maduros_(45_-_59_años)';
  if (age >= 60) return 'Mixto_Adultos_Mayores_(60_años_o_más)';

  return null;
};

/** Same composition (hombres, mujeres o mixto): Cypher + also searches Jóvenes (18–25). */
const YOUTH_ACTIVITY_BY_CYPHER_PLUS = {
  'Hombres_Cypher_+_(18_-21_años)': 'Hombres_Jóvenes_(18-25_años)',
  'Mujeres_Cypher_+_(18_-21_años)': 'Mujeres_Jóvenes_(18-25_años)',
  'Mixtos_Cypher_+_(18_-21_años)': 'Mixto_Jóvenes_(18-25_años)',
};

/**
 * Activity names to query with the existing groups search.
 * Ages 18–21 keep their Cypher + category and also the overlapping Jóvenes (18–25) category.
 */
export const getGroupSearchActivityNames = (activityName) => {
  if (!activityName) return [];
  const youthActivity = YOUTH_ACTIVITY_BY_CYPHER_PLUS[activityName];
  return youthActivity ? [activityName, youthActivity] : [activityName];
};

const getCouplesActivityName = ({ birthdate }) => {
  if (!birthdate) return 'Parejas_Adultas_Jóvenes_(26_-_44)';

  const age = getAge(birthdate);
  if (age >= 45) return 'Parejas_Adultas_Mayores_(45_años_o_más)';
  return 'Parejas_Adultas_Jóvenes_(26_-_44)';
};

export const isCoupleCivilStatus = (civil) => civil === 'Casado' || civil === 'Union libre';

/** Whether the user should pick a group type before searching. */
export const hasMixedGroupOption = ({ gender, birthdate, civil }) => {
  if (!gender || !birthdate) return false;

  if (isCoupleCivilStatus(civil)) return true;

  return Boolean(
    getGenderSpecificActivityName({ gender, birthdate }) && getMixedActivityName({ birthdate })
  );
};

/** Profile summary shown on the preference step and personal form. */
export const getNewMemberCategoryInfo = ({
  gender,
  birthdate,
  civil,
  preferMixed = false,
  preferCouples = false,
}) => {
  if (!birthdate) return null;

  const age = getAge(birthdate);
  const activityName = getNewMemberActivityName({
    gender,
    birthdate,
    civil,
    preferMixed,
    preferCouples,
  });

  const searchedNames = getGroupSearchActivityNames(activityName);
  const categoryLabel = [
    ...new Set(searchedNames.map((name) => groupsTranslationMap[name] || name.replace(/_/g, ' '))),
  ].join(' y ');
  const activityLabel = activityName ? activityName.replace(/_/g, ' ') : '';

  return { age, categoryLabel, activityLabel, activityName };
};

/** Resolves the discipleship activityName key from form data. */
export const getNewMemberActivityName = ({
  gender,
  birthdate,
  civil,
  preferMixed = false,
  preferCouples = false,
}) => {
  if (preferCouples) {
    return getCouplesActivityName({ birthdate });
  }

  if (!gender || !birthdate) return null;

  if (preferMixed) {
    return getMixedActivityName({ birthdate });
  }

  return getGenderSpecificActivityName({ gender, birthdate });
};
